import React from 'react';

// The unit calculator's layout in grey: header controls and stats, then the projections
// area. One placeholder for the whole load — the route shows it while the calculator's
// code downloads (App.tsx Suspense), the calculator while its settings and asset values
// load — so it reads as one load, not two different screens.
const Bone: React.FC<{ className?: string }> = ({ className = '' }) => <span className={`block rounded-md bg-slate-200 animate-pulse ${className}`} />;
const CalculatorSkeleton: React.FC = () => (
    <div className="h-full bg-slate-50 flex flex-col overflow-hidden" role="status" aria-label="Loading calculator">
        <div className="bg-white border-b border-slate-200 px-4 py-3">
            <div className="flex items-center justify-between gap-3 overflow-hidden">
                <div className="flex items-center gap-3 shrink-0">
                    {['w-12', 'w-28', 'w-24', 'w-20', 'w-20'].map((w, i) => (
                        <div key={i} className="flex flex-col items-center gap-1.5 px-2">
                            <Bone className="h-2.5 w-10" />
                            <Bone className={`h-5 ${w}`} />
                        </div>
                    ))}
                </div>
                <div className="hidden md:flex items-center gap-4 shrink-0">
                    {[0, 1, 2].map(i => (
                        <div key={i} className="flex flex-col items-center gap-1.5">
                            <Bone className="h-2.5 w-14" />
                            <Bone className="h-5 w-20" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <div className="flex-1 p-4 flex flex-col gap-3 min-h-0">
            <div className="flex gap-2">{[0, 1, 2, 3].map(i => <Bone key={i} className="h-9 w-28" />)}</div>
            <div className="flex-1 rounded-2xl bg-white ring-1 ring-slate-200 p-4 flex flex-col gap-3">
                <Bone className="h-6 w-56" />
                {Array.from({ length: 8 }).map((_, i) => <Bone key={i} className="h-8 w-full" />)}
            </div>
        </div>
        <span className="sr-only">Loading calculator…</span>
    </div>
);

export default CalculatorSkeleton;
